<template>
  <div class="core">
    <div class="layui-fluid">
      <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="服务商表.xlsx">
        <template>
          <button class="layui-btn" title="新增服务商" @click="addService">
            <i class="layui-icon">&#xe624;</i>
            新增服务商
          </button>
          <button class="layui-btn" title="导入" @click="importExcel()">
                <span style="display:none" id="importWarpper">
                  <form enctype="multipart/form-data" style="margin-top: 20px;margin-bottom:10px;">
                      <div style="margin-left: 8.33333333%;">
                          <input type="file" id="file" accept=".xls,.xlsx"/>
                         <div style="margin-top:10px;padding-top:5px">
                          <a style="cursor:pointer;color: blue" href="/static/template/服务商信息模板.xlsx"
                                  class="btn btn-default btn-xs"><i class="fa fa-file-excel-o"></i> 下载模板</a>
                        </div>
                          <font color="red" style="margin-top:10px;display: block;">
                            提示：仅允许导入“xls”或“xlsx”格式文件！
                          </font>
                      </div>
                  </form>
                </span>
            <i class="layui-icon">&#xe624;</i>
            导入
          </button>
        </template>
      </pub-search>
      <layui-table
        ref="service"
        table-name="YW_SERVICER"
        :page-size="20"
        :page-range="6"
        :page-options="[10, 20, 50, 100]"
        :skin="'line'"
        :sort="['CREATE_TIME:DESC']"
        @table-event-edit="edit($event)"
        @table-event-check="check($event)"
        @table-event-del="$refs.service.delRows($event.data)"
        :beforeRender="handleBeforeRnder"
      >
        <div>
          <div checkbox="true" align="center" fixed="left" width="60"></div>
          <!-- <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div> -->
          <layui-tableconfig :config = "tableList"></layui-tableconfig>
          <div rowspan="3" align="center" fixed="right" title="操作" width="130">
            <script type="text/html" v-pre>
              <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
              <a class=" layui-btn-xs" lay-event="edit" style="cursor:pointer">编辑</a>
              <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del" style="cursor:pointer">删除</a>
            </script>
          </div>
        </div>
      </layui-table>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'serviceRequest',
  data () {
    return {
      tableList:[
        { field: 'SERVICE_NUM', title: '服务商编号', sort: true,width: 150},
        { field: 'SERVICE_NAME', title: '服务商名称' ,width: 220},
        { field: 'SERVICE_NATURE_DESC', title: '服务商性质', width: 160, translateDomain: 'TRNSLATE_SERVICE_NATURE'},
        { field: 'SERVICE_TYPE_DESC', title: '服务类型', width: 160},
        { field: 'SSD_DESC', title: '所属地' , width: 260 },
        { field: 'CONTACT_PERSON', title: '联系人姓名' ,width: 150},
        { field: 'PHONE_NUM', title: '联系电话', width: 150 },
        { field: 'IS_BILL_DESC', title: '是否开票',width: 140, translateDomain: 'TRNSLATE_SF'},
        { field: 'BILL_NAME', title: '开票名称', width: 150 },
        { field: 'BZ', title: '备注', width: 200 },
      ],
      searchConfig: {
        basic: [
          { TYPE:'input', WIDTH: 260, FIELD: 'SERVICE_NUM:2,SERVICE_NAME:2,PHONE_NUM:2', PLACEHOLDER: '请输入搜索条件'},
        ],
        advanced: [
          { TYPE:'input', NAME: '服务商编号 :', FIELD:'SERVICE_NUM:2', PLACEHOLDER: '请输入查询条件'},
          { TYPE:'input', NAME: '服务商名称 :', FIELD:'SERVICE_NAME:2', PLACEHOLDER: '请输入查询条件'},
          { TYPE:'input', NAME: '联系电话 :', FIELD:'PHONE_NUM:2', PLACEHOLDER: '请输入查询条件'},
          // { TYPE:'input', NAME: '门店名称 :', FIELD:'SSX:2', PLACEHOLDER: '请输入查询条件'},
          { TYPE:'layui-multiselect', NAME: '服务类型:', FIELD: 'SERVICE_TYPE:1',textField: 'text', valueField: 'value',initData:this.dict.getData('FILTER_SERVICE_TYPE'),},
          { TYPE:'layui-multiselect', NAME: '服务商性质:', FIELD: 'SERVICE_NATURE:1',textField: 'text', valueField: 'value',initData:this.dict.getData('SERVICE_NATURE'),},
          { TYPE:'layui-multiselect', NAME: '是否开票:', FIELD: 'IS_BILL:1',textField: 'text', valueField: 'value',initData:this.dict.getData('FILTER_SF'),},
        ],
        showBatch: true
      },
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      managerForm: false,
    }
  },
  mounted(){
    this.tableObj = this.$refs.service;
  },
  methods: {
    /**
     * 新增服务商
     */
    addService () {
      this.baseComponent.smartLoadComponent('serviceForm', {serviceRequest: this, tableObj: this.tableObj, formType: 'add', title: '新增服务商'})
    },
    /**
     * 编辑表格
     */
    edit($event){
      this.baseComponent.smartLoadComponent('serviceForm', {serviceRequest: this, editRow: $event.data, tableObj: this.tableObj, formType: 'edit', title: '编辑服务商'})
    },
    check($event){
      this.baseComponent.smartLoadComponent('serviceForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'browser', title: '查看服务商'})
    },
    handleBeforeRnder(data){
      if(data && data.length > 0) {
        data.forEach((e) => {
          e.SSD = (e.PROVINCE ? e.PROVINCE : '') + "," + (e.CITY ? e.CITY : '') + "," + (e.DISTRICT ? e.DISTRICT : '')
          e.SSD_DESC = (e.PROVINCE ? e.PROVINCE_DESC : '') + "" + (e.CITY ? "-" + e.CITY_DESC: '') + "" + (e.DISTRICT ?  "-" + e.DISTRICT_DESC : '')
        })
      }
    },
    importExcel(){
      var that = this;
      this.layui.layer.open({
        type: 1,
        area: ['400px', '230px'],
        fix: false,
        //不固定
        maxmin: true,
        shade: 0.3,
        title: '上传数据',
        content: $('#importWarpper').html(),
        btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
        // 弹层外区域关闭
        shadeClose: true,
        btn1: function(index, layero){
          var file = layero.find('#file').val();
          if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))){
            that.layer.openAlert("请选择后缀为 “xls”或“xlsx”的文件。");
            return false;
          }
          var index = layer.load(2, {shade: false});
          var formData = new FormData();
          formData.append("file", layero.find('#file')[0].files[0]);
          $.ajax({
            url: process.env.API_HOST + '/newData/import/servicer?token=' + that.security.getToken(),
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function (result) {
              layer.closeAll();
              if(result.errorMsg){
                that.layer.openAlert(result.errorMsg);
                return;
              }
              result = result.result;
              layer.close(index);
              if(result != ""){
                that.$nextTick(()=> {
                  that.tableObj.load();
                });
              }
            },
            error: function(err){
              layer.close(index);
            }
          });
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/servicePManage/index.vue